'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = createStore;

var _redux = require('redux');

var _promise = require('./middlewares/promise');

var _promise2 = _interopRequireDefault(_promise);

var _pages = require('./middlewares/pages');

var _pages2 = _interopRequireDefault(_pages);

var _geocoding = require('./middlewares/geocoding');

var _geocoding2 = _interopRequireDefault(_geocoding);

var _storage = require('./middlewares/storage');

var _storage2 = _interopRequireDefault(_storage);

var _analytics = require('./middlewares/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _reactRouterRedux = require('react-router-redux');

var _config = require('config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDataWithLocalStore = function getDataWithLocalStore(data) {
  if (_config.ENABLE_LOCAL_STORAGE && _config.CLIENT && window && window.localStorage) {
    return (0, _extends3.default)({}, data, JSON.parse(localStorage.getItem(_config.LOCAL_STORE_KEY)));
  }

  return data;
};

function createStore(history, data) {
  // Sync dispatched route actions to the history
  var reduxRouterMiddleware = (0, _reactRouterRedux.routerMiddleware)(history);

  var middleware = [_promise2.default, _analytics2.default, _pages2.default, _geocoding2.default, reduxRouterMiddleware, _storage2.default];

  var parsedData = getDataWithLocalStore(data);

  var finalCreateStore = void 0;
  if (_config.NODE_ENV === 'development' && _config.CLIENT) {
    finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : function (f) {
      return f;
    })(_redux.createStore);
  } else {
    finalCreateStore = _redux.applyMiddleware.apply(undefined, middleware)(_redux.createStore);
  }

  var reducer = require('./reducer');
  var store = finalCreateStore(reducer, parsedData);

  if (_config.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./reducer', function () {
      store.replaceReducer(require('./reducer'));
    });
  }

  return store;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/createStore.js
// module id = 1295
// module chunks = 0